// ADR-198: Reports → Scheduled Jobs (radar-api /api/reports/scheduled-jobs).
import { authenticatedApi, ApiError, API_BASE_URL } from './apiUtils';

const BASE = `${API_BASE_URL}/reports/scheduled-jobs`;

export const scheduledJobsApi = {
  /** @returns {Promise<{ service, categories, schedulers }>} */
  getOverview: async ({ upcoming = 5 } = {}) => {
    try {
      return await authenticatedApi.get(`${BASE}?upcoming=${encodeURIComponent(upcoming)}`);
    } catch (error) {
      throw new ApiError(error?.message || 'Failed to load scheduled jobs', error?.status || 500, error?.data || null);
    }
  },
};
